import { Action } from '@ngrx/store';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import { IApiAutomationQueryParams } from '../shared/api-automation.model';
import { IApiAutomationOption } from '../shared/api-automation.model';
import {
  ITagCombination,
  ITagCombinationRow,
} from '../../../../view/settings/api-automation-settings/tag-combinations/tag-combinations.model';

export enum ActionTypes {
  TAG_COMBINATIONS_DATA_LOADING = '[TAG_COMBINATIONS] TAG_COMBINATIONS DATA LOADING',
  TAG_COMBINATIONS_DATA_LOADED = '[TAG_COMBINATIONS] TAG_COMBINATIONS DATA LOADED',
  GET_TAG_COMBINATION = '[TAG_COMBINATIONS] GET_TAG_COMBINATION LOADING',
  GET_TAG_COMBINATION_COMPLETED = '[TAG_COMBINATIONS] GET_TAG_COMBINATION COMPLETED',
  ADD_TAG_COMBINATION = '[TAG_COMBINATIONS] ADD_TAG_COMBINATION',
  ADD_TAG_COMBINATION_COMPLETED = '[TAG_COMBINATIONS] ADD_TAG_COMBINATION COMPLETED',
  EDIT_TAG_COMBINATION = '[TAG_COMBINATIONS] EDIT_TAG_COMBINATION',
  EDIT_TAG_COMBINATION_COMPLETED = '[TAG_COMBINATIONS] EDIT_TAG_COMBINATION COMPLETED',
  DELETE_TAG_COMBINATIONS = '[TAG_COMBINATIONS] DELETE_TAG_COMBINATIONS',
  DELETE_TAG_COMBINATIONS_COMPLETED = '[TAG_COMBINATIONS] DELETE_TAG_COMBINATIONS COMPLETED',
  DESTINATIONS_DATA_LOADING = '[TAG_COMBINATIONS] DESTINATIONS DATA LOADING',
  DESTINATIONS_DATA_COMPLETED = '[TAG_COMBINATIONS] DESTINATIONS DATA COMPLETED',
  HEARTBEAT_SETTINGS_DATA_LOADING = '[TAG_COMBINATIONS] HEARTBEAT_SETTINGS DATA LOADING',
  HEARTBEAT_SETTINGS_DATA_COMPLETED = '[TAG_COMBINATIONS] HEARTBEAT_SETTINGS DATA COMPLETED',
  DESTINATION_MAP_DATA_LOADING = '[TAG_COMBINATIONS] DESTINATION_MAP DATA LOADING',
  DESTINATION_MAP_DATA_COMPLETED = '[TAG_COMBINATIONS] DESTINATION_MAP DATA COMPLETED',
  FETCH_ERROR = '[TAG_COMBINATIONS] FETCH ERROR',
}

export class TagCombinationsLoading implements Action {
  readonly type = ActionTypes.TAG_COMBINATIONS_DATA_LOADING;

  constructor(public params: IApiAutomationQueryParams) {}
}

export class TagCombinationsLoaded implements Action {
  readonly type = ActionTypes.TAG_COMBINATIONS_DATA_LOADED;

  constructor(public payload: GetManyResponseInterface<ITagCombination>) {}
}

export class GetTagCombination implements Action {
  readonly type = ActionTypes.GET_TAG_COMBINATION;

  constructor(public recordId: number) {}
}

export class GetTagCombinationCompleted implements Action {
  readonly type = ActionTypes.GET_TAG_COMBINATION_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<ITagCombination>) {}
}
export class AddTagCombination implements Action {
  readonly type = ActionTypes.ADD_TAG_COMBINATION;

  constructor(
    public record: ITagCombinationRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class AddTagCombinationCompleted implements Action {
  readonly type = ActionTypes.ADD_TAG_COMBINATION_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<ITagCombination>) {}
}
export class EditTagCombination implements Action {
  readonly type = ActionTypes.EDIT_TAG_COMBINATION;

  constructor(
    public recordId: number,
    public record: ITagCombinationRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class EditTagCombinationCompleted implements Action {
  readonly type = ActionTypes.EDIT_TAG_COMBINATION_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<ITagCombination>) {}
}
export class DeleteTagCombinations implements Action {
  readonly type = ActionTypes.DELETE_TAG_COMBINATIONS;

  constructor(public payload: number[]) {}
}

export class DeleteTagCombinationsCompleted implements Action {
  readonly type = ActionTypes.DELETE_TAG_COMBINATIONS_COMPLETED;

  constructor(
    public isBulk: boolean,
    public response: BulkResponseDataInterface,
  ) {}
}
export class DestinationsDataLoading implements Action {
  readonly type = ActionTypes.DESTINATIONS_DATA_LOADING;

  constructor(public tagType: string) {}
}

export class DestinationsDataCompleted implements Action {
  readonly type = ActionTypes.DESTINATIONS_DATA_COMPLETED;

  constructor(public payload: IApiAutomationOption[]) {}
}
export class HeartbeatSettingsDataLoading implements Action {
  readonly type = ActionTypes.HEARTBEAT_SETTINGS_DATA_LOADING;
}

export class HeartbeatSettingsDataCompleted implements Action {
  readonly type = ActionTypes.HEARTBEAT_SETTINGS_DATA_COMPLETED;

  constructor(public payload: IApiAutomationOption[]) {}
}
export class DestinationMapDataLoading implements Action {
  readonly type = ActionTypes.DESTINATION_MAP_DATA_LOADING;

  constructor(public tagTypes: string[]) {}
}

export class DestinationMapDataCompleted implements Action {
  readonly type = ActionTypes.DESTINATION_MAP_DATA_COMPLETED;

  constructor(public payload: Record<string, IApiAutomationOption[]>) {}
}
export class FetchError implements Action {
  readonly type = ActionTypes.FETCH_ERROR;

  constructor(public errorAction: ActionTypes) {}
}

export type TagCombinationActions =
  | TagCombinationsLoading
  | TagCombinationsLoaded
  | GetTagCombination
  | GetTagCombinationCompleted
  | AddTagCombination
  | AddTagCombinationCompleted
  | EditTagCombination
  | EditTagCombinationCompleted
  | DeleteTagCombinations
  | DeleteTagCombinationsCompleted
  | DestinationsDataLoading
  | DestinationsDataCompleted
  | HeartbeatSettingsDataLoading
  | HeartbeatSettingsDataCompleted
  | DestinationMapDataLoading
  | DestinationMapDataCompleted
  | FetchError;
